<template>
  <main class="login-shell">
    <section class="login-visual-panel" aria-hidden="true">
      <div class="login-visual-overlay">
        <div class="login-visual-content">
          <img class="login-visual-mark" src="@/assets/images/gpr_logo.png" alt="" />
          <p class="login-eyebrow">GPR Suite</p>
          <h1>Gestión que conecta estrategia y ejecución</h1>
          <p class="login-visual-copy">
            Centraliza proyectos, objetivos, presupuestos e indicadores en una sola plataforma.
          </p>
          <p class="login-capabilities">Proyectos · OKR · Presupuesto · Indicadores</p>
        </div>
        <p class="login-visual-footer">GPR Suite · Innovahtec</p>
      </div>
    </section>

    <section class="login-access-panel">
      <div class="login-card">
        <div class="login-brand">
          <img class="login-logo login-logo--banner" src="@/assets/images/gpr_banner.png" alt="GPR Suite" />
          <img class="login-logo login-logo--symbol" src="@/assets/images/gpr_logo.png" alt="GPR Suite" />
          <p class="login-client-badge">Configurado para Surexport</p>
        </div>

        <div class="login-heading">
          <h2>Bienvenido</h2>
          <p>Ingresa con tus credenciales para acceder a tu espacio de gestión.</p>
        </div>

        <v-form ref="form" v-model="valid" lazy-validation action="/" class="login-form" @submit.prevent="submit">
          <v-text-field
            v-model="usuario"
            :rules="usuarioRules"
            label="Usuario"
            class="login-input"
            required
            outlined
            uppercase
            prepend-inner-icon="fas fa-id-badge"
            color="#C41230"
            @blur="upperCase"
          >
          </v-text-field>
          <v-text-field
            v-model="clave"
            :rules="claveRules"
            label="Contraseña"
            required
            outlined
            class="login-input"
            color="#C41230"
            :type="show1 ? 'text' : 'password'"
            :append-icon="show1 ? 'fas fa-eye' : 'fas fa-eye-slash'"
            @click:append="show1 = !show1"
          ></v-text-field>
          <!-- <v-select
            :items="data"
            v-model="empresa"
            :rules="empresaRules"
            label="Empresa"
            outlined
            required
            prepend-inner-icon="fas fa-building"
          ></v-select> -->
          <v-btn
            :loading="loading"
            :disabled="!valid || loading"
            block
            depressed
            type="submit"
            class="login-primary-btn"
          >
            INICIAR SESIÓN
          </v-btn>
        </v-form>

        <div class="login-separator">
          <span></span>
          <p>o continuar con</p>
          <span></span>
        </div>

        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              outlined
              block
              class="login-corporate-btn"
              v-bind="attrs"
              v-on="on"
              @click="showCorporateAccessMessage"
            >
              <v-icon left size="20">mdi-shield-account</v-icon>
              Continuar con cuenta corporativa
            </v-btn>
          </template>
          <span>Google Workspace o Microsoft 365, según la configuración de tu organización.</span>
        </v-tooltip>

        <p class="login-corporate-hint">
          Google Workspace o Microsoft 365, según la configuración de tu organización.
        </p>

        <p class="login-help">¿Necesitas ayuda para ingresar?</p>
      </div>
    </section>
  </main>
</template>

<script>
import LoginService from '../services/LoginService';
import Swal from 'sweetalert2';
//import fire from '@/fire';
//import { decryptAES, decryptData, encryptAES } from '@/components4x/utils/utils4x';
import { decryptAES, encryptAES } from '@/components4x/utils/utils4x';

export default {
  name: 'Login',
  data: () => ({
    loading: false,
    loginService: null,
    valid: true,
    clave: '',
    empresa: '',
    show1: false,
    usuario: '',
    claveRules: [(v) => !!v || 'Contraseña es requerida.'],
    usuarioRules: [(v) => !!v || 'Usuario es requerido.'],
    empresaRules: [(v) => !!v || 'Empresa es requerida'],
    checkbox: false,
    data: []
  }),
  methods: {
    upperCase() {
      this.usuario = this.usuario.toUpperCase();
    },
    async iniciaData() {
      const res = await this.loginService.get().execResource('empresas', {
        api_token: 'BBBBBBBBBBB*cXXVOkdQgiJBJBBCKF53UZkX'
      });
      res.forEach((element) => {
        this.data.push({ text: element.razonsocial, value: element.idempresa });
      });
    },
    async submit() {
      this.$refs.form.validate();
      if (this.$refs.form.validate(true)) {
        this.loading = true;
        const res = await this.loginService.post().execResource('login', {
          usuario: this.usuario,
          clave: this.clave
        });

        if (!res.status) {
          await Swal.fire({
            icon: 'error',
            title: res.message,
            confirmButtonText: `OK`
          });
          this.loading = false;
          return;
        }
        if (parseInt(res.data.user.dias) <= 15) {
          if (res.data.user.dias <= 0) {
            await Swal.fire({
              icon: 'error',
              title: `Su licencia ha vencido, no cuenta con acceso al sistema...`,
              confirmButtonText: `OK`
            });
            this.loading = false;
            return;
          }
          await Swal.fire({
            icon: 'warning',
            title: `Quedan ${res.data.user.dias} dias de prueba...`,
            confirmButtonText: `OK`
          });
        }
        const localReady = await this.setLocal(res);
        if (!localReady) {
          this.loading = false;
          return;
        }
        await this.loadSettings();
        //await this.loadPermissions();
        await this.cargarProyeccionMO();
        this.loading = false;
        await this.$router.push({ path: '/inicio' });
      }
    },
    async setLocal(res) {
      const idempresa = res && res.data && res.data.user ? res.data.user.idempresa : '';
      if (typeof idempresa !== 'string' || idempresa.trim() === '') {
        await Swal.fire({
          icon: 'error',
          title: 'El usuario no tiene una empresa activa asignada.',
          confirmButtonText: `OK`
        });
        return false;
      }
      localStorage.setItem('token', res.data.token);
      localStorage.setItem('emp', encryptAES(idempresa)); // Empresa
      localStorage.setItem('user', encryptAES(this.usuario));
      localStorage.setItem('password', encryptAES(this.clave));
      //-----------------------------------------------
      localStorage.setItem('nc4rhtcc976', res.data.user.nombresresponsable);
      localStorage.setItem('k3rtxqdp234', res.data.user.idarea);
      localStorage.setItem('oq1rcizm635', res.data.user.idsubarea);
      localStorage.setItem('iow5csjr398', res.data.user.remail);
      localStorage.setItem('lrd5qwlr674', res.data.user.idresponsable);
      return true;
    },
    showCorporateAccessMessage() {
      Swal.fire({
        icon: 'info',
        title: 'El acceso con cuenta corporativa estará disponible próximamente.',
        confirmButtonText: 'Entendido',
        confirmButtonColor: '#C41230'
      });
    },
    async loadPermissions() {
      /*const id = localStorage.getItem('lrd5qwlr674');
      if (id === null) return;

      const role = await this.$store.getters.getRole;
      if (role === '') return;

      const ref = fire.firestore().collection('modules_auth');

      console.log(ref);
      const response = await ref.where('roles', 'array-contains', role).get();

      // console.log('response', response.docs);

      if (response.empty) return;

      const permissions = [];

      response.forEach((doc) => {
        permissions.push(doc.data().code);
      });

      await this.$store.dispatch('updatePermission', permissions);*/
    },
    async cerrarSesion() {
      const res = await this.loginService.get().execResource('cerrarSesion');
      if (res.status) {
        localStorage.removeItem('token');
        localStorage.removeItem('lrd5qwlr674');
        localStorage.removeItem('iow5csjr398');
        localStorage.removeItem('nc4rhtcc976');
        localStorage.removeItem('k3rtxqdp234');
        localStorage.removeItem('oq1rcizm635');
        await this.$store.dispatch('updateReset');
        this.$router.push({ path: '/auth/login' });
      }
    },
    async loadSettings() {
      /*const id = localStorage.getItem('lrd5qwlr674');
      if (id === null) return;

      const decryptId = decryptData(id);

      const config = await fire
        .firestore()
        .collection('users')
        .doc(decryptId)
        .get();

      if (!config.exists) return;

      this.$vuetify.theme.dark = config.data().themedark;
      this.$store.commit('SET_SIDEBAR_COLOR', config.data().sidebarcolor);
      this.$store.commit('SET_THEME_COLOR', config.data().themecolor);
      await this.$store.dispatch('updateRole', config.data().role);
      await this.$store.dispatch('updateProfile', config.data().profile);*/

      //---------------------------------------------------------------
      const res = await this.loginService.get().execResource('configuraciones');
      if (res[0].activo == 1) {
        this.$vuetify.theme.dark = Number(res[0].themedark);
        this.$store.commit('SET_SIDEBAR_COLOR', res[0].sidebarcolor);
        this.$store.commit('SET_THEME_COLOR', res[0].themecolor);
        await this.$store.dispatch('updateProfile', res[0].permisos);
        await this.$store.dispatch('updateRole', res[0].role);
        await this.$store.dispatch('updatePermission', res[0].module_code);
      } else {
        this.cerrarSesion();
      }
    },
    async cargarProyeccionMO() {
      console.log('cargar proyeccion mo');
      const res = await this.loginService.get().execResource('proyeccionMo');
      await this.$store.dispatch('cargarProyeccionMO', res);
      console.log(this.$store, 'storeeee');
    }
  },
  async created() {
    this.usuario = decryptAES(localStorage.getItem('user'));
    this.clave = decryptAES(localStorage.getItem('password'));
    this.empresa = decryptAES(localStorage.getItem('emp'));
  },
  async mounted() {
    if (localStorage.getItem('token') !== null) {
      await this.$router.push({ path: '/inicio' });
    } else {
      this.loginService = this.$httpService(new LoginService(), this);
      await this.iniciaData();
    }
  }
};
</script>

<style lang="css">
.login-shell {
  display: flex;
  min-height: 100vh;
  width: 100%;
  overflow-x: hidden;
  background: #f8fafc;
  color: #071b4a;
}

@supports (min-height: 100dvh) {
  .login-shell {
    min-height: 100dvh;
  }
}

.login-visual-panel {
  position: relative;
  flex: 0 0 58%;
  min-height: 100vh;
  background-image: linear-gradient(
      100deg,
      rgba(15, 23, 42, 0.76) 0%,
      rgba(15, 23, 42, 0.58) 52%,
      rgba(196, 18, 48, 0.22) 100%
    ),
    url('../../../assets/images/logo_gestion.jpg');
  background-position: center;
  background-size: cover;
}

.login-visual-overlay {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100%;
  padding: 72px clamp(48px, 7vw, 112px) 42px;
}

.login-visual-content {
  max-width: 620px;
  margin-top: auto;
  margin-bottom: auto;
}

.login-visual-mark {
  width: 58px;
  height: auto;
  margin-bottom: 30px;
}

.login-eyebrow {
  margin: 0 0 18px;
  color: #fbecef;
  font-size: 0.86rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.login-visual-content h1 {
  margin: 0;
  color: #ffffff;
  font-size: clamp(2.25rem, 4vw, 4.25rem);
  font-weight: 700;
  line-height: 1.06;
  letter-spacing: 0;
}

.login-visual-copy {
  max-width: 560px;
  margin: 24px 0 0;
  color: rgba(255, 255, 255, 0.84);
  font-size: clamp(1rem, 1.3vw, 1.2rem);
  line-height: 1.65;
}

.login-capabilities {
  display: inline-flex;
  margin: 30px 0 0;
  padding: 12px 16px;
  border: 1px solid rgba(251, 236, 239, 0.5);
  border-radius: 8px;
  color: #ffffff;
  font-size: 0.94rem;
  font-weight: 600;
  background: rgba(196, 18, 48, 0.18);
}

.login-visual-footer {
  margin: 0;
  color: rgba(255, 255, 255, 0.68);
  font-size: 0.9rem;
}

.login-access-panel {
  display: flex;
  flex: 0 0 42%;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 48px clamp(32px, 4vw, 72px);
  background: #f8fafc;
}

.login-card {
  width: 100%;
  max-width: 420px;
}

.login-brand {
  margin-bottom: 34px;
}

.login-logo {
  display: block;
  height: auto;
}

.login-logo--banner {
  width: min(260px, 78%);
}

.login-logo--symbol {
  display: none;
  width: 82px;
}

.login-client-badge {
  display: inline-flex;
  margin: 16px 0 0;
  padding: 6px 10px;
  border-radius: 999px;
  color: #9f1028;
  background: #fbecef;
  font-size: 0.78rem;
  font-weight: 700;
  line-height: 1.2;
}

.login-heading {
  margin-bottom: 26px;
}

.login-heading h2 {
  margin: 0 0 10px;
  color: #071b4a;
  font-size: 2rem;
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: 0;
}

.login-heading p {
  margin: 0;
  color: #64748b;
  font-size: 0.98rem;
  line-height: 1.55;
}

.login-form {
  width: 100%;
}

.login-input {
  margin-bottom: 4px;
}

.login-input .v-input__slot {
  min-height: 52px !important;
  border-radius: 8px !important;
  background: #ffffff !important;
}

.login-input input {
  min-height: 48px;
  font-size: 16px;
}

.login-input .v-label {
  color: #64748b;
}

.login-primary-btn {
  min-height: 48px !important;
  margin-top: 4px;
  border-radius: 8px !important;
  background-color: #c41230 !important;
  color: #ffffff !important;
  font-weight: 700;
  letter-spacing: 0;
}

.login-primary-btn:not(.v-btn--disabled):hover {
  background-color: #9f1028 !important;
}

.login-primary-btn.v-btn--disabled {
  background-color: rgba(196, 18, 48, 0.42) !important;
  color: rgba(255, 255, 255, 0.9) !important;
}

.login-separator {
  display: flex;
  align-items: center;
  gap: 14px;
  margin: 28px 0 18px;
}

.login-separator span {
  flex: 1;
  height: 1px;
  background: #d7dee8;
}

.login-separator p {
  margin: 0;
  color: #64748b;
  font-size: 0.85rem;
  white-space: nowrap;
}

.login-corporate-btn {
  min-height: 48px !important;
  border: 1px solid #c7d2e2 !important;
  border-radius: 8px !important;
  color: #071b4a !important;
  font-weight: 700;
  letter-spacing: 0;
  text-transform: none;
  background: #ffffff !important;
}

.login-corporate-btn:hover {
  border-color: #c41230 !important;
  color: #9f1028 !important;
  background: #fbecef !important;
}

.login-corporate-hint {
  margin: 10px 0 0;
  color: #64748b;
  font-size: 0.82rem;
  line-height: 1.45;
  text-align: center;
}

.login-help {
  margin: 30px 0 0;
  color: #9f1028;
  font-size: 0.92rem;
  font-weight: 600;
  text-align: center;
}

@media (max-width: 1024px) and (min-width: 768px) {
  .login-visual-panel {
    flex-basis: 45%;
    background-position: center;
  }

  .login-access-panel {
    flex-basis: 55%;
    padding: 38px 34px;
  }

  .login-visual-overlay {
    padding: 54px 34px 34px;
  }

  .login-visual-mark {
    width: 48px;
    margin-bottom: 22px;
  }

  .login-visual-content h1 {
    font-size: 2.3rem;
  }

  .login-visual-copy {
    font-size: 0.96rem;
  }

  .login-capabilities {
    display: none;
  }
}

@media (max-width: 767px) {
  .login-shell {
    display: block;
    min-height: 100vh;
  }

  .login-visual-panel {
    display: none;
  }

  .login-access-panel {
    min-height: 100vh;
    padding: 34px 22px;
    overflow-y: auto;
  }

  .login-card {
    max-width: 430px;
  }

  .login-brand {
    margin-bottom: 28px;
  }

  .login-logo--banner {
    width: min(230px, 82vw);
  }

  .login-heading h2 {
    font-size: 1.8rem;
  }

  .login-heading p,
  .login-corporate-hint,
  .login-help {
    font-size: 0.95rem;
  }

  .login-corporate-btn .v-btn__content {
    white-space: normal;
    line-height: 1.25;
  }
}

@media (max-width: 380px) {
  .login-access-panel {
    padding-right: 20px;
    padding-left: 20px;
  }

  .login-logo--banner {
    display: none;
  }

  .login-logo--symbol {
    display: block;
  }
}

@media (max-height: 700px) {
  .login-access-panel {
    align-items: flex-start;
    padding-top: 24px;
    padding-bottom: 24px;
  }

  .login-brand {
    margin-bottom: 20px;
  }

  .login-heading {
    margin-bottom: 20px;
  }

  .login-separator {
    margin-top: 22px;
  }
}
</style>
